module.exports = __webpack_public_path__ + "img/08_DSC7755-mobileVersion.93b62c4f.jpg";